import request from '@/utils/request'
import { v2Host } from '@/config/host'

export function submitGmakerJob(data) {
  return request({
    url: `${v2Host}/gmaker/job/submit`,
    method: 'post',
    data,
  })
}

export function getGmakerJobList(params) {
  return request({
    url: `${v2Host}/gmaker/job/list`,
    method: 'get',
    params,
  })
}

export function cancelGmakerJob(params) {
  return request({
    url: `${v2Host}/gmaker/job/cancel`,
    method: 'get',
    params,
  })
}
